import type { IconData } from '@stacksjs/iconify-core'

export const bh4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0\"/><path fill=\"#ce1126\" d=\"M640 0H96l110.7 48L96 96l110.7 48L96 192l110.7 48L96 288l110.7 48L96 384l110.7 48L96 480h544\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default bh4x3
